import React from "react";

const CustomChekbox = ({ label, value, isChecked, onChange }) => {
  return (
    <div className="flex items-center space-x-2">
      {isChecked ? (
        <div
          className="w-[14px] min-w-[14px] h-[14px] border border-primary bg-primary rounded-[4px] cursor-pointer flex justify-center items-center"
          onClick={() => onChange(value)}
        >
          <svg
            width="13"
            height="10"
            viewBox="0 0 17 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.1422 1.24264L5.24268 11.1421L1.00004 6.89949"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      ) : (
        <div
          className="w-[14px] min-w-[14px] h-[14px] border border-[#A8B5C2]  rounded-[4px] cursor-pointer"
          onClick={() => onChange(value)}
        />
      )}

      <span className="text-xs text-secondary ">{label}</span>
    </div>
  );
};

export default CustomChekbox;
